import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

export function BrandingHead() {
  const { branding } = useAuth();
  useEffect(() => {
    if (branding?.application_name) document.title = branding.application_name;
    const fav = branding?.favicon_url;
    if (fav) {
      const url = fav.startsWith("http") ? fav : `${process.env.REACT_APP_BACKEND_URL}${fav}`;
      let link = document.querySelector("link[rel='icon']");
      if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
      link.href = url;
    }
    // PWA icon (apple-touch-icon) - prefer pwa_icon_url, fallback favicon
    const pwa = branding?.pwa_icon_url || branding?.favicon_url;
    if (pwa) {
      const url = pwa.startsWith("http") ? pwa : `${process.env.REACT_APP_BACKEND_URL}${pwa}`;
      let apple = document.querySelector("link[rel='apple-touch-icon']");
      if (!apple) { apple = document.createElement("link"); apple.rel = "apple-touch-icon"; document.head.appendChild(apple); }
      apple.href = url;
    }
  }, [branding]);
  return null;
}
